import Vue from 'vue'
import Vuex from 'vuex'
import { createStorage } from 'vuex-localstorage'

Vue.use(Vuex)

const guestUser = {
  loggedIn: false,
  name: 'guest'
}

const persist = createStorage({
  namespace: 'ulockme',
  initialState: {
    user: guestUser
  }
})

/*
|---------------------------------------------------
| State
|---------------------------------------------------
*/
const state = {
  user: persist.get('user'),
  progress: 0,
  notification: null
}

/*
|---------------------------------------------------
| Getters
|---------------------------------------------------
*/
const getters = {
  loggedIn: state => state.user.loggedIn,
  currentUser: state => state.user,
  hasPermission: state => ({ permission, serverId }) => {
    const allowedOnServers = state.user.permissions
      .filter(p => p.appFunctions.includes(permission))

    if (!allowedOnServers.length) {
      return false
    }

    // If this permission is enabled on central then it should be enabled for every server
    if (allowedOnServers.filter(p => p.server.isCentral).length) {
      return true
    }

    if (!serverId) {
      return allowedOnServers.filter(p => p.server.isSelf).length
    }

    return allowedOnServers.filter(p => p.server.id === serverId).length
  }
}

/*
|---------------------------------------------------
| Mutations
|---------------------------------------------------
*/
export const mutations = {
  updateUser (state, user) {
    state.user = user
    persist.set('user', user)
  },
  resetUser (state) {
    state.user = guestUser
    persist.set('user', guestUser)
  },
  INCREMENT_PROGRESS (state) {
    state.progress = state.progress + 1
  },
  DECREMENT_PROGRESS (state) {
    state.progress = state.progress - 1
  },
  SHOW_NOTIFICATION (state, notification) {
    state.notification = notification
  }
}

/*
|---------------------------------------------------
| Actions
|---------------------------------------------------
*/
const actions = {}

/*
|---------------------------------------------------
| Plugins
|---------------------------------------------------
*/

import socketPlugin from './plugins/socketPlugin'

/*
|---------------------------------------------------
| Modules
|---------------------------------------------------
*/
import moduleFactory from './moduleFactory'

import appFunctions from './modules/app-functions'
import scheduledJobs from './modules/scheduled-jobs'

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    ...[
      'users',
      'persons',
      'owners',
      'organizations',
      'user-levels',
      'servers',
      'controllers',
      'switch-groups',
      'mobiles',
      'switches',
      'mobile-groups',
      'locations',
      'event-types',
      'preregistrations',
      'access-schemes',
      'external-services',
      'readers',
      'inputs',
      'system-parameters',
      'pending-mobile-accesses',
      'mobile-notification-settings'
    ].reduce((acc, curr) => ({ ...acc, [curr]: moduleFactory(curr) }), {}),
    'app-functions': appFunctions,
    'scheduled-jobs': scheduledJobs
  },
  plugins: [socketPlugin],
  /* eslint-disable no-undef */
  strict: process.env.NODE_ENV !== 'production'
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js